export default __webpack_public_path__ + "static/inno-biz-2af28702415aebe4afcb27c02d0c876d.png";